import {PlanSettingsCountryEnum} from 'client';
import {useGetPlanSettings} from './swr';
import useParseURL from './useParseURL';

export const useGetIsChilePlan = (): {isChilePlan: boolean; conversionRate: number} => {
  const {planId} = useParseURL();
  const {data: planSettings} = useGetPlanSettings({resourceId: planId});
  const isChilePlan = planSettings?.country === PlanSettingsCountryEnum.Chile;
  const conversionRate = isChilePlan ? planSettings?.nokToUsdExchangeRate : 1;

  return {isChilePlan, conversionRate};
};
